import { createSelector } from 'reselect';
import { getPartOperationFingerprint } from 'lib/selectors/getPartOperationFingerprint';

export const getIsAPMEnabled = createSelector(
  [getPartOperationFingerprint],
  (fingerprint) => {
    return !!fingerprint?.isEnabled;
  }
);
